<template>
  <div>
    <div class="option">
      <div class="title-option-head">ตัวเลือกสินค้า</div>
      <div class="title">ราคาขายปกติ</div>
      <div class="title">ราคาลดเหลืิอ</div>
      <div class="title">ราคาขายต่อครั้ง</div>
      <div class="title"></div>
    </div>
    <div v-if="packageOptionPrices"></div>
    <div
      class="table-option"
      v-for="(
        packageOptionPrice, packageOptionPriceIndex
      ) in packageOptionPrices"
      :key="packageOptionPriceIndex"
    >
      <div class="combine-option-head">
        <div class="title-header" v-if="!packageOptionPrice.service_main_option">
          {{ packageOptionPrice.service_title }}
        </div>
        <div v-else class="title-option-head">
          {{ packageOptionPrice.service_title }}
        </div>
        <div class="title-price" v-if="!packageOptionPrice.service_main_option">
          <div>
            <el-input
              class="input-price"
              type="number"
              min="0"
              :value="packageOptionPrice.service_original_price"
              :readonly="handleReadOnlyPrice(
                readOnlyPrices,
                packageOptionPrice.service_id,
                packageOptionPrice.is_discount
              )"
              @input="handleChangeInputService(
                $event,
                'service_original_price',
                packageOptionPrice.service_id
              )"
            ></el-input>
          </div>
          <div>
            <el-input
              class="input-price"
              type="number"
              min="0"
              :value="packageOptionPrice.service_price"
              :readonly="handleReadOnlyPrice(
                readOnlyPrices,
                packageOptionPrice.service_id,
                packageOptionPrice.is_discount
              ) || !packageOptionPrice.is_discount"
              :disabled="!packageOptionPrice.is_discount"
              @input="handleChangeInputService(
                $event,
                'service_price',
                packageOptionPrice.service_id
              )"
            ></el-input>
          </div>
          <div>
            <div
              class="table-detail-price"
              v-for="(
                serviceAppointmentPrice, serviceAppointmentPriceIndex
              ) in packageOptionPrice.service_appointment_prices"
              :key="serviceAppointmentPriceIndex"
            >
              <div
                v-if="packageOptionPrice.is_appointment"
                class="option-price"
              >
                ครั้งที่: {{ serviceAppointmentPrice.appoint_no }}
              </div>
              <div v-else class="option-price">สินค้า</div>
              <div>
                <el-input
                  class="input-price"
                  type="number"
                  min="0"
                  :value="serviceAppointmentPrice.appoint_price"
                  :readonly="handleReadOnlyPrice(
                    readOnlyPrices,
                    packageOptionPrice.service_id,
                    packageOptionPrice.is_discount
                  ) || !packageOptionPrice.is_discount"
                  @input="handleChangeInputServiceAppointment(
                    $event,
                    'appoint_price',
                    packageOptionPrice.service_id,
                    serviceAppointmentPrice.appoint_no
                  )"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="menu-status">
            <div class="checkbox-option">
              <el-checkbox
                :value="packageOptionPrice.is_out_of_stock"
                @input="handleChangeInputService(
                  $event,
                  'is_out_of_stock',
                  packageOptionPrice.service_id
                )"
                :disabled="disabled"
                >หมดสต๊อก</el-checkbox
              >
            </div>
            <div class="sub-title-price">
              <el-checkbox
                :value="packageOptionPrice.is_discount"
                @input="handleChangeInputService(
                  $event,
                  'is_discount',
                  packageOptionPrice.service_id
                )"
                :disabled="disabled"
                >ลดราคา</el-checkbox
              >
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="(
          optionVariant, optionVariantIndex
        ) in packageOptionPrice.service_option_variants"
        :key="optionVariantIndex"
      >
        <div
          v-for="(variant, variantIndex) in optionVariant.variants"
          :key="variantIndex"
        >
          <div class="combine-option-sub">
            <div class="title-option">
              <div v-if="variantIndex === 0">{{ variant.title }}</div>
              <div v-else>+ {{ variant.title }}</div>
            </div>
            <div class="title-price">
              <div>
                <el-input
                  type="number"
                  min="0"
                  :value="variant.original_price"
                  :readonly="handleReadOnlyPrice(
                    readOnlyOptionVariantPrice,
                    variant.id,
                    variant.is_discount
                  )"
                  @input="handleChangeInputOption(
                    $event,
                    'original_price',
                    packageOptionPrice.service_id,
                    optionVariant.id,
                    variant.id
                  )"
                ></el-input>
              </div>
              <div>
                <el-input
                  type="number"
                  min="0"
                  :value="variant.price"
                  :readonly="handleReadOnlyPrice(
                    readOnlyOptionVariantPrice,
                    variant.id,
                    variant.is_discount
                  ) || !variant.is_discount"
                  @input="handleChangeInputOption(
                    $event,
                    'price',
                    packageOptionPrice.service_id,
                    optionVariant.id,
                    variant.id
                  )"
                ></el-input>
              </div>
              <div>
                <div
                  class="table-detail-price"
                  v-for="(
                    appointmentPrice, appointmentPriceIndex
                  ) in variant.appointment_prices"
                  :key="appointmentPriceIndex"
                >
                  <div
                    v-if="packageOptionPrice.is_appointment"
                    class="option-price"
                  >
                    ครั้งที่: {{ appointmentPrice.appoint_no }}
                  </div>
                  <div v-else class="option-price">สินค้า</div>
                  <div>
                    <el-input
                      class="input-price"
                      type="number"
                      min="0"
                      :value="appointmentPrice.appoint_price"
                      :readonly="handleReadOnlyPrice(
                        readOnlyOptionVariantPrice,
                        variant.id,
                        variant.is_discount
                      ) || !variant.is_discount"
                      @input="handleChangeInputOptionAppointment(
                        $event,
                        'appoint_price',
                        packageOptionPrice.service_id,
                        optionVariant.id,
                        variant.id,
                        appointmentPrice.appoint_no
                      )"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="menu-status-option">
                <div class="status">
                  <div class="status-active" v-if="!variant.is_out_of_stock">
                    มีในสต๊อก
                  </div>
                  <div class="status-not-active" v-else>หมดสต๊อก</div>
                </div>
                <div class="status">
                  <div class="status-active" v-if="!variant.is_not_sale">
                    ขาย
                  </div>
                  <div class="status-not-active" v-else>ไม่ขาย</div>
                </div>
                <div class="sub-title-price">
                  <el-checkbox
                    :value="variant.is_discount"
                    @input="handleChangeInputOption(
                      $event,
                      'is_discount',
                      packageOptionPrice.service_id,
                      optionVariant.id,
                      variant.id
                    )"
                    >ลดราคา</el-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input, Checkbox } from "element-ui";
import { formatDecimal } from "@/lib/formatter";

export default {
  components: {
    "el-input": Input,
    "el-checkbox": Checkbox,
  },
  props: ["value", "disabled"],
  computed: {
    packageOptionPrices: {
      get() {
        return this.value.packageOptions;
      },
    },
    readOnlyPrices() {
      return this.value.newServicePrices;
    },
    readOnlyOptionVariantPrice() {
      return this.value.newOptionVariantPrices;
    }
  },
  methods: {
    handleChangeInputService(event, key, serviceId) {
      const packageOptionPrices = this.value.packageOptions.forEach((service) => {
        if (service.service_id === serviceId) {
          switch (key) {
            case "service_price":
              service.service_price = event;

              this.calculateTotalPackagePrice();
              this.calculateAppointmentPrice(service);
              break;
            case "service_original_price":
              service.service_original_price = event;

              if (!service.is_discount) {
                service.service_price = event;
              }

              this.calculateTotalPackagePrice();
              this.calculateAppointmentPrice(service);
              break;
            case "is_out_of_stock":
              service.is_out_of_stock = event;
              break;
            case "is_discount":
              service.is_discount = event;

              if (event === false) {
                service.service_price = service.service_original_price;
                this.calculateTotalPackagePrice();
                this.calculateAppointmentPrice(service);
              }
              break;
            default:
              break;
          }
        }
      });

      this.$emit("input", { packageOptionPrices });
    },
    handleChangeInputServiceAppointment(event, key, serviceId, appointmentNo) {
      const packageOptionPrices = this.value.packageOptions.forEach((service) => {
        if (service.service_id === serviceId) {
          service.service_appointment_prices.forEach((appointmentPrice) => {
            if (appointmentNo === appointmentPrice.appoint_no) {
              switch (key) {
                case "appoint_price":
                  appointmentPrice.appoint_price = event;
                  break;
                default:
                  break;
              }
            }
          });
        }
      });

      this.$emit("input", { packageOptionPrices });
    },
    handleChangeInputOption(event, key, serviceId, optionVariantId, variantId) {
      const packageOptionPrices = this.value.packageOptions.forEach((service) => {
        if (service.service_id === serviceId) {
          service.service_option_variants.forEach((option) => {
            if (option.id === optionVariantId) {
              option.variants.forEach((variant) => {
                if (variant.id === variantId) {
                  switch (key) {
                    case "price":
                      variant.price = event;

                      this.calculateTotalPackagePrice();
                      this.calculateAppointmentOptionPrice(variant);
                      break;
                    case "is_out_of_stock":
                      variant.is_out_of_stock = event;
                      break;
                    case "original_price":
                      variant.original_price = event;

                      if (!variant.is_discount) {
                        variant.price = event;
                      }

                      this.calculateTotalPackagePrice();
                      this.calculateAppointmentOptionPrice(variant);
                      break;
                    case "is_discount":
                      variant.is_discount = event;

                      if (event === false) {
                        variant.price = variant.original_price;
                        this.calculateTotalPackagePrice();
                        this.calculateAppointmentOptionPrice(variant);
                      }
                      break;
                    default:
                      break;
                  }
                }
              });
            }
          });
        }
      });

      return this.$emit("input", { packageOptionPrices });
    },
    handleChangeInputOptionAppointment(
      event,
      key,
      serviceId,
      optionVariantId,
      variantId,
      apppointmentNo
    ) {
      const packageOptionPrices = this.value.packageOptions.forEach((service) => {
        if (service.service_id === serviceId) {
          service.service_option_variants.forEach((option) => {
            if (option.id === optionVariantId) {
              option.variants.forEach((variant) => {
                if (variant.id === variantId) {
                  variant.appointment_prices.forEach((appointmentPrice) => {
                    if (appointmentPrice.appoint_no === apppointmentNo) {
                      switch (key) {
                        case "appoint_price":
                          appointmentPrice.appoint_price = event;
                          break;
                        default:
                          break;
                      }
                    }
                  });
                }
              });
            }
          });
        }
      });

      return this.$emit("input", { packageOptionPrices });
    },
    calculateTotalPackagePrice() {
      // ราคาขายที่ไม่ใช่ option / service
      const totalServicePrice = this.value.packageOptions
        .map((packageOption) => {
          const servicePrice = packageOption.service_price
            ? parseFloat(packageOption.service_price)
            : 0;

          return servicePrice;
        })
        .reduce((a, b) => a + b, 0);

      // ราคาขายราย option / service
      const totalServiceOptionPrice = this.value.packageOptions.map(
        (packageOption) => {
          const serviceOptionVariant = packageOption.service_option_variants
            ? packageOption.service_option_variants.map(
              (optionVariant) => {
                const variantsExistPrice = optionVariant.variants.filter(
                  (variant) => !!variant.price
                  && variant.price >= 0
                  && variant.extra_option === false
                  && !variant.is_not_sale
                  && !variant.is_out_of_stock
                );

                const price = variantsExistPrice.length > 0
                  ? variantsExistPrice.map(
                    (variant) => parseFloat(variant.price)
                  ).reduce((a, b) => a + b, 0)
                  : Number.MAX_VALUE;

                return price;
              }
            ).sort((a, b) => a - b)[0]
            : 0;

          return serviceOptionVariant;
        }
      ).reduce((a, b) => a + b, 0);

      const totalPrice = totalServicePrice + totalServiceOptionPrice;
      this.$emit("totalPrice", totalPrice);
    },
    handleReadOnlyPrice(listIds, id, isDiscount) {
      const newReadOnlyOptionPrice = listIds.length > 0
        ? listIds.find((item) => item === id)
        : undefined;

      const isReadOnlyOptionPrice = !this.value.isReadOnlyOptionPrice
        && !newReadOnlyOptionPrice
        && !isDiscount;

      return isReadOnlyOptionPrice;
    },
    calculateAppointmentOptionPrice(variant) {
      const appointmentOptionLength = variant.appointment_prices.length

      let priceForCalculateLastIndex = 0
      variant.appointment_prices.forEach((appointmentPrice, index) => {
        appointmentPrice.appoint_price = formatDecimal(variant.price / appointmentOptionLength)

        if (variant.appointment_prices.length === 1) {
          appointmentPrice.appoint_price = formatDecimal(variant.price / appointmentOptionLength)
        } else if (variant.appointment_prices.length - 1 !== index) {
          appointmentPrice.appoint_price = formatDecimal(variant.price / appointmentOptionLength)

          priceForCalculateLastIndex = formatDecimal(priceForCalculateLastIndex + appointmentPrice.appoint_price)
        } else if (variant.appointment_prices.length - 1 === index) {
          appointmentPrice.appoint_price = formatDecimal(variant.price - priceForCalculateLastIndex)
        }
      })
    },
    calculateAppointmentPrice(service) {
      const appointmentLength = service.service_appointment_prices.length

      let priceForCalculateLastIndex = 0
      service.service_appointment_prices.forEach((appointmentPrice, index) => {
        if (service.service_appointment_prices.length === 1) {
          appointmentPrice.appoint_price = formatDecimal(service.service_price / appointmentLength)
        } else if (service.service_appointment_prices.length - 1 !== index) {
          appointmentPrice.appoint_price = formatDecimal(service.service_price / appointmentLength)

          priceForCalculateLastIndex = formatDecimal(priceForCalculateLastIndex + appointmentPrice.appoint_price)
        } else if (service.service_appointment_prices.length - 1 === index) {
          appointmentPrice.appoint_price = formatDecimal(service.service_price - priceForCalculateLastIndex)
        }

      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.table-option {
  border: $border-head;
  border-top: 0;
}

.option {
  border: $border-head;
  height: 50px;
  background: #f2f2f2;

  display: grid;
  grid-template-columns: 320px 100px 100px 230px 300px;
}

.title-price {
  font-size: 12px;
  font-weight: normal;

  display: grid;
  grid-template-columns: 100px 100px 230px 300px;
}

.title-option {
  padding: 10px;
  border-right: $border;
  font-size: 12px;
  font-weight: normal;
}

.title {
  &-option-head {
    padding: 10px;

    font-size: 15px;
    font-weight: bold;
  }

  &-header {
    padding: 10px;

    font-size: 15px;
    font-weight: bold;
    border-right: $border;
  }
}

.combine-option-head {
  padding-left: 25px;
  border: $border-head;

  display: grid;
  grid-template-columns: 294px 100px 100px 230px 300px;
}

.combine-option-sub {
  padding-left: 25px;
  border: $border;

  display: grid;
  grid-template-columns: 294px 100px 100px 230px 300px;
}

.sub-title-price {
  padding-top: 5px;
}

.checkbox-option {
  border-left: $border;
  padding-top: 5px;
  padding-left: 5px;
}

.status {
  padding-left: 10px;
  padding-top: 5px;

  &-active {
    color: rgb(9, 128, 5);
  }

  &-not-active {
    color: rgb(247, 1, 1);
  }
}

.table-detail {
  border-left: $border;

  &-price {
    border-left: $border;
    display: grid;
    grid-template-columns: 115px 115px;
  }
}

.el-input {
  width: 100%;
  height: 100%;
}

.title {
  border-left: $border;
  font-size: 12px;
  font-weight: normal;
  padding: 10px;
}

.option-price {
  border-left: $border;
  border-bottom: $border;
  padding-top: 5px;
  padding-left: 30px;
  border-radius: 0px;
}

.input-price {
  border-radius: 0px;
}

.menu-status {
  display: grid;
  grid-template-columns: 110px 90px;

  font-size: 12px;
  font-weight: normal;
}

.menu-status-option {
  display: grid;
  grid-template-columns: 70px 50px 80px;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/packages/components/PackageOptionPriceEditor.vue